export default {
  namespaced: true,
  state: {
    connectionError: false,
    authorizationError: false,
    serverError: false
  },
  mutations: {
    connectionError(state, payload) {
      state.connectionError = payload
    },
    authorizationError (state, payload) {
      state.authorizationError = payload
    },
    serverError (state, payload) {
      state.serverError = payload
    },
    clear(state) {
      state.connectionError = false
      state.authorizationError = false
      state.serverError = false
    }
  },
  getters: {
    showInternetLost(state) {
      return state.connectionError || state.serverError
    },
    showGlobalInterceptError (state) {
      return state.connectionError || state.authorizationError || state.serverError
    },
    globalInterceptMessageKey (state) {
      if(state.authorizationError) return 'ac_common.not_authorized'
      else if(state.connectionError) return 'ac_common.no_internet'
      else if (state.serverError) return 'ac_common.server_error'
    }
  }
}
